import { render, staticRenderFns } from "./ai-bot-support-channel.vue?vue&type=template&id=5142724a&"
import script from "./ai-bot-support-channel.vue?vue&type=script&lang=js&"
export * from "./ai-bot-support-channel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports